/**
 * @generated SignedSource<<b609a754e2779b35c1f797df62ba2dfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityStartEndTime_facility$data = {
  readonly startEndTime: {
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityStartEndTime_facility";
};
export type useFacilityStartEndTime_facility$key = {
  readonly " $data"?: useFacilityStartEndTime_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityStartEndTime_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityStartEndTime_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityStartEndTime",
      "kind": "LinkedField",
      "name": "startEndTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "3817b3d52aad95c5a29a42f3b5659516";

export default node;
